import { RequestMethods } from '../../constants';
import { api } from '../../';
import { UserDetails } from './constants';
import type { UserFitnessProfile } from '~/redux/api/routes/UserApi/models';
import type { PostVoidResponse } from '~/redux/api/models';

export const userApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUserDetails: builder.query<UserFitnessProfile, void>({
      query: () => ({
        url: UserDetails.getUserDetails,
        method: RequestMethods.GET,
      }),
      providesTags: ['User'],
      keepUnusedDataFor: 3600,
    }),

    updateUserInfo: builder.mutation<
      UserFitnessProfile,
      Partial<Omit<UserFitnessProfile, 'id'>>
    >({
      query: (userData) => ({
        url: UserDetails.getUserDetails,
        method: RequestMethods.PATCH,
        body: userData,
      }),
      invalidatesTags: ['User'],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedUser } = await queryFulfilled;

          dispatch(
            userApi.util.updateQueryData(
              'getUserDetails',
              undefined,
              (draft) => {
                Object.assign(draft, updatedUser);
              }
            )
          );
        } catch (err) {
          console.error(err);
        }
      },
    }),

    deletePersonalDetails: builder.mutation<PostVoidResponse, void>({
      query: () => ({
        url: UserDetails.getUserDetails,
        method: RequestMethods.DELETE,
      }),
      invalidatesTags: ['User'],
    }),

    downloadPersonalDetails: builder.mutation<PostVoidResponse, string>({
      query: (email) => ({
        url: UserDetails.downloadPersonalDetails,
        method: RequestMethods.POST,
        body: { email },
      }),
    }),
  }),
});

export const {
  useGetUserDetailsQuery,
  useUpdateUserInfoMutation,
  useLazyGetUserDetailsQuery,
  useDeletePersonalDetailsMutation,
  useDownloadPersonalDetailsMutation,
} = userApi;
